export default "__VITE_ASSET__f10d4814__"